"use client";

// Third-party Libraries
import Image from "next/image";

// Assets
import googleLogo from "../../public/google.png";

export function GoogleSignInButton({ handleClick }: { handleClick: () => void }) {
  return (
    <button
      onClick={handleClick}
      className="w-full flex items-center font-semibold justify-center h-14 px-6 mt-4 text-lg sm:text-xl transition-colors duration-300 bg-white border-2 border-black text-black rounded-lg focus:shadow-outline hover:bg-slate-200"
    >
      <Image src={googleLogo} alt="Google Logo" width={20} height={20} />
      <span className="ml-4 text-sm sm:text-base">Continue with Google</span>
    </button>
  );
}

export function GithubSignInButton({handleClick}: {handleClick: () => void}) {

  return (
    <button
      onClick={handleClick}
      className="w-full flex items-center font-semibold justify-center h-14 px-6 mt-4 text-xl transition-colors duration-300 bg-white border-2 border-black text-black rounded-lg focus:shadow-outline hover:bg-slate-200"
    >
      <span className="ml-4">Continue with Github</span>
    </button>
  );
}

export function CredentialsSignInButton({handleClick}: {handleClick: () => void}) {

  return (
    <button
      onClick={handleClick}
      className="w-full flex items-center font-semibold justify-center h-14 px-6 mt-4 text-xl transition-colors duration-300 bg-white border-2 border-black text-black rounded-lg focus:shadow-outline hover:bg-slate-200"
    >
      <span className="ml-4">Continue with Email</span>
    </button>
  );
}